import { ClickReporter, Reporter, Tracker } from '@ai-saas/tracker';
import { reportClickEvent } from '@/services/ant-design-pro/tracker';

export const tracker = new Tracker();
export const reporter = new Reporter();
export const clickReporter = new ClickReporter();

// 点击事件上报：注入请求函数 + 连接 tracker + 注册卸载兜底
clickReporter.debug = true;
clickReporter.setRequest((payload) => reportClickEvent(payload).then(() => {}));
tracker.setClickHandler((payload) => clickReporter.report(payload));
clickReporter.setupUnloadHandler();
